import { ResponseBase } from './../../../interfaces/response-base';
import { of } from 'rxjs';
import { IsLoadingService } from './../../../services/is-loading.service';
import { VeiculosService } from './../../../services/veiculos.service';
import { Component, OnInit } from '@angular/core';
import { Veiculo } from 'app/models/veiculo/veiculo';

@Component({
  selector: 'app-consultar',
  templateUrl: './consultar.component.html',
  styleUrls: ['./consultar.component.scss']
})
export class ConsultarComponent implements OnInit {
  public veiculo: Veiculo;
  public notFound = false;

  constructor(
    private veiculoService: VeiculosService,
    private loadingService: IsLoadingService) { }

  ngOnInit() {
  }

  buscarPlaca(placa: string) {
    this.loadingService.isLoading = of(true);

    this.veiculoService.buscarPlaca(placa)
      .then((response: ResponseBase<Veiculo>) => {
        this.veiculo = response.data;
        this.notFound = !this.veiculo.placa;
        this.loadingService.isLoading = of(false);
      })
      .catch((err: any) => {
        this.loadingService.isLoading = of(false);
      });
  }



}
